module.exports = __webpack_public_path__ + "static/media/CTLA_1-127w.a207cc33.jpg";